import angular from 'angular';

angular.module('cloudX').directive('checkAdvancedUpload', function() {
  var isAdvancedUpload = (function() {
    var div = document.createElement('div');
    return (
      ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
      'FormData' in window &&
      'FileReader' in window
    );
  })();
  return {
    restrict: 'A',
    link: function($scope, $element) {
      if (!isAdvancedUpload) $element.remove();
    },
  };
});
